import { createClient } from '@supabase/supabase-js'

const SUPABASE_URL = 'https://omzogperuzukeeearioo.supabase.co';
const SUPABASE_ANON_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Im9tem9ncGVydXp1a2VlZWFyaW9vIiwicm9sZSI6ImFub24iLCJpYXQiOjE3ODcwNjcyNTIsImV4cCI6MjEwMjY0MzI1Mn0.svJ7vz6nvYestFr16gQVNzJRYeUL3bmHzTkYDLEykWQ';

if(!SUPABASE_URL || !SUPABASE_ANON_KEY ){
  throw new Error('Missing Supabase variables');
}

export default createClient(SUPABASE_URL, SUPABASE_ANON_KEY, {
  auth: {
    persistSession: true,
    autoRefreshToken: true
  }
});